import axios from 'axios';

// Get the API base URL using the same logic as api.js
const getBaseUrl = () => {
  // If environment variable is set, use it
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Otherwise, derive it from the current host
  const { protocol, hostname, port } = window.location;

  // If we're running on localhost with a specific port for frontend
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // For local development, the backend is typically running on port 8020
    return 'http://localhost:8020';
  }

  // For production, use the same origin since the FastAPI backend serves the frontend
  return window.location.origin;
};

// Create an axios instance with default config
const agentApi = axios.create({
  baseURL: getBaseUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to include the token in all requests
agentApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor to handle authentication errors
agentApi.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 Unauthorized errors
    if (error.response && error.response.status === 401) {
      // Clear token from localStorage
      localStorage.removeItem('token');

      // Redirect to login page if not already there
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// API functions for agent service
export const agentService = {
  // List all registered agents
  listAgents: async () => {
    try {
      const response = await agentApi.get('/api/agent/agents/list');
      return response.data;
    } catch (error) {
      console.error('Error listing agents:', error);
      throw error;
    }
  },

  // List all available tools
  listTools: async () => {
    try {
      const response = await agentApi.get('/api/agent/tools/list');
      return response.data;
    } catch (error) {
      console.error('Error listing tools:', error);
      throw error;
    }
  },

  // Call a specific tool
  callTool: async (toolName, params = {}) => {
    try {
      const response = await agentApi.post(`/api/agent/tools/call/${toolName}`, params);
      return response.data;
    } catch (error) {
      console.error(`Error calling tool '${toolName}':`, error);
      throw error;
    }
  }
};

export default agentApi;
